//
//
//
//
//
//

export default {
    props: [
        'name',
        'milliseconds',
        'text',
        'type',
        'repeat'
    ],
    
    computed: {
        output() {
            var fullTimerOutput = "";
            var shortTimerOutput = "";

            if (this.minute > 0) {
                fullTimerOutput += this.minute + " " + 'мин' + " ";
                shortTimerOutput +=  this.addZero(this.minute) + " : ";
            }
            if(this.minute == 0){
                fullTimerOutput += this.minute + " " + 'мин' + " ";
                shortTimerOutput += this.addZero(this.minute) + " : ";
            }
            if (this.second > 0) {
                fullTimerOutput += this.second + " " + 'сек' + " ";
                shortTimerOutput += this.addZero(this.second);
            } else {
                shortTimerOutput += "00";
            }

            if (this.minute + this.second > 0)
            {
                if (this.type == 'short') {
                    return shortTimerOutput;
                } else {
                    return this.text + " " + fullTimerOutput;
                }
                
            } else {
                return "";
            }
        },
    },
    created() {
       this.startTimer();
    },
    data() {
        return {
            interval: {},
            minute: 0,
            second: 0,
            count: 0
        }
    },
    watch: {
        milliseconds(val, oldVal) {
            console.log("watch");
                console.log(val);
                this.minute = Math.trunc(val / 60000);
                this.second = (val - this.minute * 60000) / 1000;
            
            if ( val != 0 ) {
                clearInterval(this.interval);
            
                this.interval = setInterval(() => { this.timer() }, 1000);
            }
            
        },
    },
    methods : {
        
        timer() {

            this.second--;

            if (this.second == -1) {
                this.second = 59;
                this.minute--;
            }

            if (this.minute == -1) {
                if(this.repeat){
                    clearInterval(this.interval);
                    this.count++;
                    if(this.repeat >= this.count){
                        this.startTimer();
                    }
                    else{
                        this.$emit("completed");
                        this.second = 0;
                    }

                }
                else{
                    clearInterval(this.interval);
                    this.$emit("completed");
                    this.second = 0;
                }


            }

        },
        addZero(num) {
            var numString = num + "";
            if (numString.length == 1) {
                numString = "0" + numString;
            }
            return numString;
        },
        startTimer(){
            var val=this.milliseconds;

            this.minute = Math.trunc(val / 60000);
            this.second = (val - this.minute * 60000) / 1000;
            clearInterval(this.interval);
            if ( val != 0 ) {
                this.interval = setInterval(() => { this.timer() }, 1000);
            }
        }
    }

}
